import { Component, OnInit, Inject } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { PageComponent, ICC_PAGE_DATA } from '@icc/configurator/shared';
import { SharedFacade } from '@icc/configurator/shared';
import { IccFilling } from '@icc/window-door/types';

@Component({
    selector: 'icc-layout-options-page',
    templateUrl: './layout-options-page.component.html',
    styleUrls: ['./layout-options-page.component.scss'],
    standalone: false,
})
export class LayoutOptionsPageComponent extends PageComponent implements OnInit {
    public title = _('DOOR|Wybór wypełnień dla wzoru');
    public options = [];

    selectedPanel: IccFilling | null = null;
    selectedGlazing: IccFilling | null = null;

    hasPanels = false;
    hasGlazings = false;

    constructor(
        private sharedFacade: SharedFacade,
        @Inject(ICC_PAGE_DATA)
        public pageData: {
            panels: IccFilling[];
            glazings: IccFilling[];
            defaultPanel: IccFilling | null;
            defaultGlazing: IccFilling | null;
            state?: { panel: IccFilling | null; glazing: IccFilling | null };
            pickFilling: (
                fillings: IccFilling[],
                selected: IccFilling | null,
            ) => Promise<{ glazing?: IccFilling; filling?: IccFilling } | undefined>;
        },
    ) {
        super();
    }

    ngOnInit() {
        this.hasPanels = (this.pageData.panels || []).length > 0;
        this.hasGlazings = (this.pageData.glazings || []).length > 0;
        if (!this.pageData.state) {
            this.pageData.state = { panel: null, glazing: null };
        }
        this.selectedPanel =
            this.pageData.state.panel
            || this.pageData.defaultPanel
            || this.pageData.panels?.[0]
            || null;
        this.selectedGlazing =
            this.pageData.state.glazing
            || this.pageData.defaultGlazing
            || this.pageData.glazings?.[0]
            || null;
        this.pageData.state.panel = this.selectedPanel;
        this.pageData.state.glazing = this.selectedGlazing;
    }

    changePanel() {
        this.pageData
            .pickFilling(this.pageData.panels, this.selectedPanel)
            .then(result => {
                const selected = result?.glazing ?? result?.filling;
                if (selected) {
                    this.selectedPanel = selected;
                    if (this.pageData.state) {
                        this.pageData.state.panel = selected;
                    }
                }
            });
    }

    changeGlazing() {
        this.pageData
            .pickFilling(this.pageData.glazings, this.selectedGlazing)
            .then(result => {
                const selected = result?.glazing ?? result?.filling;
                if (selected) {
                    this.selectedGlazing = selected;
                    if (this.pageData.state) {
                        this.pageData.state.glazing = selected;
                    }
                }
            });
    }

    save() {
        this.sharedFacade.closePage({
            panel: this.selectedPanel,
            glazing: this.selectedGlazing,
        });
    }
}
